/**
 * Initialize search functionality
 */
const siteSearch = () => {
  const docBody = document.body;
  const searchTrigger = docBody.querySelectorAll(".search-trigger");
  const fullScreenSearch = docBody.querySelector(".fullscreen-search");
  const searchForm = docBody.querySelector("#search-form");
  const close = docBody.querySelector(".close-search");

  if (!searchTrigger || !fullScreenSearch || !searchForm || !close) return;

  let isSearchActive = false;

  const activateSearch = () => {
    isSearchActive = true;
    fullScreenSearch.classList.add("active");
    docBody.classList.add("no-scroll");
    setTimeout(() => {
      searchForm.focus();
    }, 200);
    document.addEventListener("keydown", handleTabKey);
  };

  const deactivateSearch = () => {
    isSearchActive = false;
    fullScreenSearch.classList.remove("active");
    docBody.classList.remove("no-scroll");
    searchTrigger[0].focus();
    searchForm.value = "";
    document.removeEventListener("keydown", handleTabKey);
  };

  const handleTabKey = (event) => {
    if (event.keyCode === 9 && isSearchActive) {
      event.preventDefault();

      if (document.activeElement === close) {
        searchForm.focus();
      } else {
        close.focus();
      }
    }
  };

  const handleEscKey = (event) => {
    const code = event.keyCode || event.which;
    if (code === 27 && isSearchActive) {
      deactivateSearch();
    }
  };

  const handleClickOutside = (event) => {
    if (
      event.target.classList.contains("active") &&
      event.target.classList.contains("fullscreen-search")
    ) {
      deactivateSearch();
    }
  };

  // Add event listeners
  searchTrigger.forEach((item) => {
    item.addEventListener("click", () => {
      if (isSearchActive) {
        deactivateSearch();
      } else {
        activateSearch();
      }
    });
  });

  docBody.addEventListener("keyup", handleEscKey);
  close.addEventListener("click", deactivateSearch);
  fullScreenSearch.addEventListener("click", handleClickOutside);
};

export { siteSearch };
